import { useFormState } from 'components/elements/form';
import saleDepartmentOptions from 'components/elements/table/editable-columns/sale-department-options';
import TableInput from 'components/elements/table/table-input';
import {
  ActionType,
  ColumnDataType,
  IColumn,
} from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { BonusPeriodFormType, SaleConfigurationFormType } from './form-type';

const name = 'saleConfigurations' as const;

function useGetSaleConfigurationTableList(): IColumn<SaleConfigurationFormType>[] {
  const { t } = useTranslation();
  return [
    {
      header: t('common:department'),
      accessorKey: 'department',
      dataType: ColumnDataType.select,
      options: saleDepartmentOptions(t),
      disabled: true,
      maxSize: 150,
    },
    {
      header: t('common:type'),
      accessorKey: 'type',
      dataType: ColumnDataType.null,
      maxSize: 150,
      disabled: true,
      cell: ({ getValue }) => <>{t(`common:${getValue() as string}`)}</>,
    },
    {
      header: t('invoice:operator_sales'),
      accessorKey: 'operatorSalesBonus',
      dataType: ColumnDataType.number,
      minNumber: 0,
      maxSize: 120,
    },
    {
      header: t('invoice:lead'),
      accessorKey: 'leadBonus',
      dataType: ColumnDataType.number,
      minNumber: 0,
      maxSize: 120,
    },
  ];
}

export default function SaleConfigurationTableInput() {
  const { editable } = useFormState();
  const { getValues, clearErrors, control } =
    useFormContext<BonusPeriodFormType>();

  const { fields, update } = useFieldArray({
    name,
    control,
  });

  const columns = useGetSaleConfigurationTableList();

  const dispatch = React.useCallback(
    (action) => {
      const sales = getValues(name);
      const currentRowIndex = action.rowIndex as number;
      const sale = sales[currentRowIndex];
      const type = action.type as ActionType;
      const columnId = action.columnId as keyof SaleConfigurationFormType;
      const value = action.value;

      if (type === 'update_cell') {
        update(currentRowIndex, {
          ...sale,
          [columnId]: value,
        });
        clearErrors(`${name}.${currentRowIndex}.${columnId}`);
      }
    },
    [clearErrors, getValues, update],
  );

  return (
    <>
      <TableInput
        columns={columns}
        data={fields}
        dispatch={dispatch}
        disabled={!editable}
        name={name}
        uniqueRowKey="customId"
        onCustomDisabledCell={({ accessorKey }) => {
          return accessorKey === 'department';
        }}
        noAddRemoveRow
      />
    </>
  );
}
